import { useMemo } from 'react';
import { FOLDER_ID, UNFILED_ASSETS_ID } from '../constants/folders';
import useCurrentFolderId from './useCurrentFolderId';
import { useIsFoldersMode } from 'framework-listing-lib/internal/hooks/useUIMode';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
const getFolderIdFromSelectedObject = selectedObject => {
  return parseInt(getPropertyValue(selectedObject, FOLDER_ID, `${UNFILED_ASSETS_ID}`) || `${UNFILED_ASSETS_ID}`, 10);
};
export default function usePreviousFolderId(selectedObjectOrObjects) {
  const isFoldersMode = useIsFoldersMode();
  const selectedFolderInFoldersMode = useCurrentFolderId();
  return useMemo(() => {
    if (isFoldersMode) {
      return {
        previousFolderId: selectedFolderInFoldersMode,
        hasPreviousFolderId: true
      };
    }
    if (!Array.isArray(selectedObjectOrObjects)) {
      return {
        previousFolderId: getFolderIdFromSelectedObject(selectedObjectOrObjects),
        hasPreviousFolderId: true
      };
    }
    if (selectedObjectOrObjects.length === 1) {
      return {
        previousFolderId: getFolderIdFromSelectedObject(selectedObjectOrObjects[0]),
        hasPreviousFolderId: true
      };
    }
    return {
      previousFolderId: undefined,
      hasPreviousFolderId: false
    };
  }, [isFoldersMode, selectedFolderInFoldersMode, selectedObjectOrObjects]);
}